import { useCallback } from 'react';
import { CALC_DIR, setCalcMonthDateObj, setCalcWeekDateObj } from '@features/calendar/core';
import { setSelectedDate, setDrawDate, selectedDrawDate } from '@features/calendar/CalendarSlice';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { setZeroPad } from '@utils/index';
import type { IDateObj, IL10n } from '@type/index';

interface IHeaderProps {
    l10n: IL10n;
}

const YMComponent = ({ l10n }: IHeaderProps) => {
    const dispatch = useAppDispatch();
    const drawDate = useAppSelector(selectedDrawDate);
    const { prevMonth, nextMonth, prevWeek, nextWeek } = l10n?.calendar || {};

    const clickCallback = useCallback((date: IDateObj) => {
        //dispatch(setDrawDate(date));
        dispatch(setSelectedDate(date));
    }, []);

    const goPrevMonth = useCallback(() => {
        const prevDate = setCalcMonthDateObj(drawDate, CALC_DIR.MINUS);
        clickCallback(prevDate);
    }, [drawDate]);

    const goNextMonth = useCallback(() => {
        const nextDate = setCalcMonthDateObj(drawDate, CALC_DIR.PLUS);
        clickCallback(nextDate);
    }, [drawDate]);

    // const goPrevWeek = useCallback(() => {
    //     const prevDate = setCalcWeekDateObj(drawDate, CALC_DIR.MINUS);
    //     clickCallback(prevDate);
    // }, [drawDate]);

    // const goNextWeek = useCallback(() => {
    //     const nextDate = setCalcWeekDateObj(drawDate, CALC_DIR.PLUS);
    //     clickCallback(nextDate);
    // }, [drawDate]);

    return <div className="calendar-header-ym">
        <h1 className="calendar-header-title">{setZeroPad(drawDate?.year)}.{setZeroPad(drawDate?.month)}.</h1>
        <div className="calendar-header-btn">
            <button type="button" className="btn-month-minus" onClick={goPrevMonth} data-contents="달력_달이동_클릭">
                <span className="hidden">{prevMonth}</span>
            </button>
            <button type="button" className="btn-month-plus" onClick={goNextMonth} data-contents="달력_달이동_클릭">
                <span className="hidden">{nextMonth}</span>
            </button>
        </div>
        {/* <div className="calendar-header-btn">
            <button type="button" className="btn-week-minus" onClick={goPrevWeek} data-contents="달력_주이동_클릭"><span className="hidden">{prevWeek}</span></button>
            <button type="button" className="btn-week-plus" onClick={goNextWeek} data-contents="달력_주이동_클릭"><span className="hidden">{nextWeek}</span></button>
        </div> */}
    </div>;
};

const DayComponent = ({ l10n }: IHeaderProps) => {
    const { sunday, monday, tuesday, wednesday, thursday, friday, saturday } = l10n?.calendar || {};
    const dayName = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
    return <div className="calendar-header-day">
        {dayName?.map((name, i) => <div key={name} className={`${i === 0 ? 'sunday' : i === 6 ? 'saturday' : ''}`}>{name}</div>)}
    </div>;
};

export const Header = ({ l10n }: IHeaderProps) => {
    return <div className="calendar-header">
        <YMComponent l10n={l10n} />
        <DayComponent l10n={l10n} />
    </div>
};